import React, { useState } from "react";
import { Button, StyledText } from "../../components/common";
import { CloseIcon } from "../../components/svgs";
import { useTheme } from "../../hooks";
import styled from "styled-components";
import NoticeImg from "../images/resume-img.png";
import ConfirmTaskResumptionModal from "./ConfirmTaskResumptionModal";

const TaskResumptionModal = ({ isOpen, onClose, title, message }) => {
  const { themeContext, theme } = useTheme();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  if (!isOpen) return null;

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <Divider onClick={onClose} />
        <Header>
          <CloseButton onClick={() => setShowConfirmModal(true)}>
            <CloseIcon />
          </CloseButton>
        </Header>

        <ContentHolder>
          <StyledText style={{ fontSize: 24 }}>
            {title && "Get back to what you were doing"}
          </StyledText>
          <IconContainer>
            <img src={NoticeImg} alt="Task resumption" />
          </IconContainer>
          <StyledText
            style={{
              textAlign: "center",
              fontFamily: "MTNRegular",
              paddingInline: 15,
            }}
          >
            {message &&
              "It seems you had something in progress. Resume now to pick up from where you left off!"}
          </StyledText>
        </ContentHolder>
        <Button
          style={{
            backgroundColor: background,
            width: "100%",
            marginBottom: "16px",
            cursor: "pointer",
          }}
        >
          <StyledText color="#fff">Continue</StyledText>
        </Button>
      </ModalContent>

      {showConfirmModal && (
        <ConfirmTaskResumptionModal
          title="Going Back Will Cancel Your Progress"
          description="If you go back now, your current process will be canceled, and you may lose your progress. Are you sure you want to continue?"
          fill={background}
          color={"white"}
          handleOnConfirm={onClose}
          hideModal={() => setShowConfirmModal(false)}
        />
      )}
    </>
  );
};

export default TaskResumptionModal;

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 10% 37px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  background-color: white;
  border-top-right-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;
const ContentHolder = styled.div`
  padding: 0 30px;
`;

const Divider = styled.div`
  width: 50px;
  height: 8px;
  background-color: #cbcbcb;
  border-radius: 10px;
  cursor: pointer;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: 40px;
  img {
    width: 100px;
  }
`;
